(() => {
  'use strict';
  if (window.FXLandingAutoplay) return;
  window.FXLandingAutoplay = true;
  const instances = new Map();
  const boot = scope => scope.querySelectorAll('.fx-gameplay-landing video[data-local-scroll-play], .fx-gameplay-landing video[data-fx-scroll-play]').forEach(video => {
    if (instances.has(video)) return;
    const frame = video.closest('.mr-autoplay-frame');
    const root = video.closest('.fx-gameplay-landing');
    const button = frame?.querySelector('[data-mr-motion]');
    if (!frame || !button) return;
    const abort = new AbortController();
    const on = (target, type, handler) => target.addEventListener(type, handler, {signal:abort.signal});
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const trailer = root.querySelector('#game-trailer-dialog');
    let loaded = false, inView = false, userPaused = false, motionOverride = false;
    const reflect = () => {
      frame.classList.toggle('is-paused', video.paused);
      frame.classList.toggle('has-reduced-motion', motion.matches);
      button.setAttribute('aria-label', video.paused ? 'Resume animation' : 'Pause animation');
      button.title = video.paused ? 'Resume animation' : 'Pause animation';
      video.dataset.mrState = video.paused ? 'paused' : 'playing';
    };
    const prepare = () => {
      if (loaded) return;
      loaded = true;
      video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
      video.preload = 'auto'; video.muted = true; video.defaultMuted = true; video.load();
    };
    const eligible = () => inView && video.isConnected && !document.hidden && !userPaused && (!motion.matches || motionOverride) && !trailer?.open;
    const sync = () => {
      if (!eligible()) { video.pause(); reflect(); return; }
      prepare();
      if (video.paused) video.play().catch(() => { reflect(); video.dataset.mrState = 'autoplay-blocked'; });
    };
    const preloadObserver = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { if (!motion.matches) prepare(); preloadObserver.disconnect(); }
    }, {rootMargin:'200px 0px'});
    const playbackObserver = new IntersectionObserver(entries => {
      const entry = entries[0]; inView = entry.isIntersecting && entry.intersectionRatio >= .2; sync();
    }, {threshold:[0,.2]});
    preloadObserver.observe(video); playbackObserver.observe(video);
    on(button, 'click', () => { userPaused = !video.paused; if (!userPaused) motionOverride = true; sync(); });
    on(video, 'playing', () => { if (!eligible()) video.pause(); reflect(); });
    on(video, 'pause', reflect);
    on(document, 'visibilitychange', sync);
    on(motion, 'change', () => { motionOverride = false; sync(); });
    const modalObserver = trailer ? new MutationObserver(sync) : null;
    if (trailer) modalObserver.observe(trailer, {attributes:true,attributeFilter:['open']});
    on(window, 'pagehide', () => video.pause()); on(window, 'pageshow', sync);
    instances.set(video, () => { video.pause(); abort.abort(); preloadObserver.disconnect(); playbackObserver.disconnect(); modalObserver?.disconnect(); instances.delete(video); });
    reflect();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), {once:true}); else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [video, dispose] of instances) if (event.target.contains(video)) dispose(); });
})();
